document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vc-carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.vc-track');
    var videos = wrap.querySelectorAll('.vc-video');
    var prevBtn = wrap.querySelector('.vc-arrow--prev');
    var nextBtn = wrap.querySelector('.vc-arrow--next');

    if (!track) return;

    // Assure muted + playsinline (obligatoire pour l'autoplay sur mobile/Safari)
    // et empêche le son + la mini-fenêtre flottante (Picture-in-Picture) que Safari
    // déclenche parfois automatiquement sur les vidéos en lecture
    videos.forEach(function (video) {
      video.muted = true;
      video.volume = 0;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');
      video.setAttribute('disablepictureinpicture', '');
      if ('disablePictureInPicture' in video) {
        video.disablePictureInPicture = true;
      }

      // Si Safari tente quand même d'ouvrir le mode PiP, on le ferme immédiatement
      video.addEventListener('enterpictureinpicture', function () {
        if (document.pictureInPictureElement) {
          document.exitPictureInPicture().catch(function () {});
        }
      });

      // Sécurité : si un script tiers ou une action utilisateur réactive le son,
      // on le recoupe immédiatement
      video.addEventListener('volumechange', function () {
        if (!video.muted || video.volume > 0) {
          video.muted = true;
          video.volume = 0;
        }
      });
    });

    function tryPlay(video) {
      video.muted = true;
      video.volume = 0;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {});
      }
    }

    // Lecture dès qu'une portion significative de la vidéo est visible dans le carrousel
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            tryPlay(video);
          } else {
            video.pause();
          }
        });
      },
      {
        root: track,
        threshold: [0, 0.25, 0.6, 1],
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });

    // Vérifie si une vidéo est actuellement visible dans le carrousel
    function isInTrackView(video) {
      var trackRect = track.getBoundingClientRect();
      var videoRect = video.getBoundingClientRect();
      return videoRect.right > trackRect.left && videoRect.left < trackRect.right;
    }

    // Tentative de lecture immédiate, sans attendre le chargement complet de la page :
    // dès que CETTE vidéo précise a assez de données, on la lance (si elle est visible)
    videos.forEach(function (video) {
      if (isInTrackView(video)) {
        tryPlay(video);
      }
      video.addEventListener('loadeddata', function () {
        if (isInTrackView(video)) {
          tryPlay(video);
        }
      });
      video.addEventListener('canplay', function () {
        if (isInTrackView(video)) {
          tryPlay(video);
        }
      });
    });

    // Flèches desktop : avance/recule d'une vidéo
    function scrollByOneSlide(direction) {
      var slide = track.querySelector('.vc-slide');
      if (!slide) return;
      var slideWidth = slide.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({
        left: direction * (slideWidth + gap),
        behavior: 'smooth',
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByOneSlide(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByOneSlide(1);
      });
    }
  });
});